import { Action, AuthenticationState, SET_AUTHENTICATION, SET_PROFILE, UPDATE_REFRESH_TOKEN, SET_COMPANY_INFO_FILLED, SET_POLICIES_CHANGED } from './type';

const initialState: AuthenticationState = {
	isAuthenticated: false,
	profile: null,
	token: null,
	refreshToken: 1,
	isCompanyInfoFilled: false,
	policiesChanged: false,
};

function rootReducer(state: AuthenticationState = initialState, action: Action): AuthenticationState {
	switch (action.type) {
		case SET_AUTHENTICATION:
			return {
				...state,
				isAuthenticated: action.profile ? true : false,
				profile: action.profile || null,
				token: action.token || null,
				isCompanyInfoFilled: action.profile && action.profile.companyInfoFilled,
				policiesChanged: false,
			};
		case SET_PROFILE:
			return {
				...state,
				profile: action.profile || null,
			};
		case SET_COMPANY_INFO_FILLED:
			return {
				...state,
				profile: action.profile || null,
				isCompanyInfoFilled: true,
			};
		case UPDATE_REFRESH_TOKEN:
			return {
				...state,
				refreshToken: state.refreshToken + 1,
			};
		case SET_POLICIES_CHANGED:
			return {
				...state,
				policiesChanged: true,
			};
		default:
			return state;
	}
}

export default rootReducer;
